/**
 * Client testimonials. The home and service pages show the testimonials
 * section only when this list has entries, so nothing appears until real
 * quotes are added. Add a client's words only with their written consent.
 *
 * Example:
 * {
 *   quote: { es: "Desde que trabajamos con Jenifer…", en: "Since working with Jenifer…" },
 *   name: "Laura G.",
 *   business: { es: "Centro de estética, Alicante", en: "Beauty centre, Alicante" },
 *   service: "gestion-instagram",
 *   photo: "/assets/testimonials/laura.webp", // optional, 160×160
 * },
 */
export type Testimonial = {
  quote: { es: string; en: string };
  name: string;
  business: { es: string; en: string };
  service?: "gestion-instagram" | "asesoria-instagram" | "pagina-web";
  photo?: string;
  /** The client's own website, linked from their name. */
  url?: string;
};

export const TESTIMONIALS: readonly Testimonial[] = [
  {
    quote: {
      es: "Excelente profesional. Desde que trabajo con Jeni, la comunicación y las redes de mi emprendimiento mejoraron muchísimo. Siempre está atenta, responde con rapidez, aporta ideas y se nota el compromiso que pone en cada detalle. La recomiendo 100%",
      /* Translated from the client's Spanish original. */
      en: "An excellent professional. Since I started working with Jeni, my business's communication and social media have improved enormously. She's always attentive, replies quickly, brings ideas and you can see the commitment she puts into every detail. I recommend her 100%.",
    },
    name: "Gisela R.",
    business: { es: "Fotografía, Santa Fe (Argentina)", en: "Photography, Santa Fe (Argentina)" },
    service: "gestion-instagram",
    photo: "/assets/testimonials/gisela-r.webp",
    url: "https://giserfotografia.com.ar/",
  },
];
